export const DICTIONARY = {
    home_title_one: {
        English: 'Welcome to Career Swipe.',
        French: `Bienvenue à Career Swipe.`,
    },
    home_subtitle_one: {
        English: 'Welcome to Career Swipe.',
        French: 'où attraction et matching vont de pair!',
    },
    introduction_title: {
        English: 'TOP TALENT IS HARD TO COME BY',
        French: 'ATTIREZ LES MEILLEURS TALENTS EN PREMIER!',
    },
    introduction_content_one_text_one: {
        English: 'Career Swipe is a',
        French: `Career Swipe est un `,
    },

    introduction_content_one_text_two: {
        English: 'Sourcing Service ',
        French: `service de recherche `,
    },

    introduction_content_one_text_three: {
        English: 'powered with AI for employers looking for qualified candidates without spending time posting or searching.',
        French: `de candidature alimenté par l'IA, pour les employeurs qui veulent trouver des candidatures de qualité sans dédier de temps à la recherche et aux affichages.`,
    },

    introduction_content_two_text_one: {
        English: 'Career Swipe offers you and ',
        French: `Career Swipe vous propose une `,
    },
    introduction_content_two_text_two: {
        English: 'innovative solution between passive posting',
        French: `solution innovante entre l'affichage passif`,
    },
    introduction_content_two_text_three: {
        English: 'and an ',
        French: `et une `,
    },
    introduction_content_two_text_four: {
        English: 'expensive recruitment service.',
        French: `coûteuse prestation de recrutement.`,
    },
    introduction_content_three_text_one: {
        English: 'A',
        French: 'Un',
    },
    introduction_content_three_text_two: {
        English: ' flexible and simple process',
        French: ' processus flexible et simple',
    },
    introduction_content_three_text_three: {
        English: ' to meet the candidates you want.',
        French: ' pour rencontrer les candidatures que vous souhaitez.',
    },
    introduction_content_four_text_one: {
        English: 'From ',
        French: `De la `,
    },
    introduction_content_four_text_two: {
        English: 'automated research',
        French: `recherche automatisée`,
    },
    introduction_content_four_text_three: {
        English: ' of the best candidates to providingreal-time labor market information. Career Swipe works to make your recruitment process a success',
        French: ` des meilleures candidatures à fournir de l'information en temps réel sur le marché du travail, Career Swipe travaille pour faire de votre processus de recrutement un succès.`,
    },
    introduction_list_item_one: {
        English: 'Receive qualified applications',
        French: 'Recevez des candidatures qualifiées',
    }, introduction_list_item_two: {
        English: 'Hire faster',
        French: 'Embauchez plus rapidement',
    }, introduction_list_item_three: {
        English: 'Keep growing',
        French: 'Continuez à croître',
    }, profile_text_experience: {
        English: 'Experience',
        French: 'Expérience'
    }, profile_text_skills: {
        English: 'Skills',
        French: 'Compétences'
    },
    profile_text_education: {
        English: 'Education',
        French: 'Formation'
    }, prices_plan_one_title: {
        English: 'Career Feed',
        French: 'Flux de Carrière'
    }, prices_plan_two_title: {
        English: 'Strategic Search',
        French: 'Recherche Ciblée'
    }, prices_plan_three_title_one: {
        English: 'Premium',
        French: 'Premium'
    }, prices_plan_three_title_two: {
        English: 'Contact Sales',
        French: 'Contacter Ventes'
    }, prices_plan_one_description: {
        English: '1 Match',
        French: '1 Match'
    }, prices_plan_two_description: {
        English: '1 Job',
        French: '1 Poste'
    }, prices_plan_three_description: {
        English: '3+ Jobs',
        French: '3+ Postes'
    }, prices_plan_one_detail_one: {
        English: 'No upfront fees',
        French: 'Aucun frais initial'
    }, prices_plan_one_detail_two: {
        English: 'Up to 50 Candidates',
        French: 'Candidatures spontanées'
    }, prices_plan_one_detail_three: {
        English: 'AI Matching',
        French: 'Matching AI simplifiée'
    }, prices_plan_one_detail_four: {
        English: 'Dashboard',
        French: 'Tableau de bord'
    }, prices_plan_two_detail_one: {
        English: 'Dynamic Job positioning',
        French: 'Position dynamique'
    }, prices_plan_two_detail_two: {
        English: 'Advanced AI Matching',
        French: 'Matching IA Advance'
    }, prices_plan_two_detail_three: {
        English: 'Dashboard',
        French: 'Tableau de bord'
    }, prices_plan_two_detail_four: {
        English: '100 direct contacts',
        French: '100 contacts directs'
    }, prices_plan_two_detail_five: {
        English: 'Real-time Market Data',
        French: 'Informations en temps réel'
    }, prices_plan_three_detail_one: {
        English: 'Dedicated researcher',
        French: 'Recherchiste dédié'
    }, prices_plan_three_detail_two: {
        English: 'Unlimited Candidates review',
        French: 'Candidatures illimitées'
    }, prices_plan_three_detail_three: {
        English: 'Stragetic Job positioning',
        French: 'Position Stratégique'
    }, prices_plan_three_detail_four: {
        English: 'Dashboard Premium',
        French: 'Tableau de bord Premium'
    }, prices_plan_three_detail_five: {
        English: 'Real-time Market Data',
        French: 'Informations en temps réel'
    }, prices_plan_three_detail_six: {
        English: 'Salary Survey',
        French: 'Sondage Salarial'
    }, profile_title: {
        English: 'PROFILE',
        French: 'PROFIL'
    }, career_swipe_process_title: {
        English: 'CAREER SWIPE PROCESS',
        French: 'NOTRE PROCESSUS'
    }, profile_page_title_1: {
        English: 'NO FEE TO REVIEW PROFILES',
        French: 'AUCUN FRAIS POUR CONSULTER LES PROFILS'
    },
    profile_page_title_2: {
        English: 'QUICK PROFILE VIEW',
        French: 'VUE RAPIDE DU PROFIL'
    },
    profile_page_title_3: {
        English: 'CLICK ACCEPT TO CONTACT CANDIDATE',
        French: 'CLIQUEZ SUR ACCEPTER POUR CONTACTER LE CANDIDAT'
    }


};